module.exports = __webpack_public_path__ + "static/media/trasa.7412317a.svg";